import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        // 
        path: '',
        name: 'menu',
        component: () => import('@/views/menu'),
        children:[
            {
                path: '',
                name: 'main',
                component: () => import('@/views/TMIP'),
            },
            {
                path: '/mes',
                name: 'mes',
                component: () => import('@/views/MES'),
            },
            {
                path: '/mtr',
                name: 'mtr',
                component: () => import('@/views/MTR'),
            },
            {
                path: '/wms',
                name: 'wms',
                component: () => import('@/views/WMS'),
            },
            {
                path: '/emv',
                name: 'emv',
                component: () => import('@/views/EMV'),
            },
            {
                path: '/service',
                name: 'service',
                component: () => import('@/views/service'),
            },
            {
                path: '/aboutus',
                name: 'aboutus',
                component: () => import('@/views/AboutUs'),
            },
            {
                path: '/tmip',
                name: 'tmip',
                component: () => import('@/views/main'),
            },
        ]
    },
]
const scrollBehavior = function(to, from, savedPosition) {
    // savedPosition 会在你使用浏览器前进或后退按钮时候生效
    // 这个跟你使用 router.go() 或 router.back() 效果一致
    // 这也是为什么我在 tab 栏结构中放入了一个 点击回退 的按钮
    // if (savedPosition) {
    //     return savedPosition
    // } else {
        // 如果不是通过上述行为切换组件，就会让页面回到顶部
        return { x: 0, y: 0 }
    // }
}
const router = new VueRouter({
    // mode:'history',
    routes,
    scrollBehavior,
})

export default router